import { Vector } from 'prelude-ts';
import { RuleExecutor } from '../Rule';
import Formula from './Formula';
import Statement from '../Statement';

/**
 * A binary connective.
 */
abstract class Connective extends Formula {
  readonly left: Formula;
  readonly right: Formula;
  constructor(left: Formula, right: Formula) {
    super();
    this.left = left;
    this.right = right;
  }

  equals(that: Formula): boolean {
    return (
      that instanceof Connective &&
      this.left.equals(that.left) &&
      this.right.equals(that.right)
    );
  }

  subFormulae(): Vector<Formula> {
    return Vector.of(this.left, this.right)
      .appendAll(this.left.subFormulae())
      .appendAll(this.right.subFormulae());
  }

  render(_subformula: Statement, _executor: RuleExecutor): JSX.Element {
    // TODO: remove
    throw Error('Unimplemented');
  }
}

export default Connective;
